export { BtnActionMobileModule } from './btn-action-mobile.module';
export { ButtonMobileAction } from './interfaces/action.interface';
